// extracted by mini-css-extract-plugin
export default {"finish-task":"FinishTask_finish-task__CG-uP","finish-task-header":"FinishTask_finish-task-header__YoPAn"};